// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './base/base.component';
// Auth
import { AuthGuard } from '../../../core/auth';
import { PurchaseComponent } from './pages/purchase/purchase.component';
import { MassPurchaseComponent } from './pages/mass-purchase/mass-purchase.component';
import { MassPurchaseGuard } from './guards/massPurchaseGuard';
import { RenewComponent } from './pages/renew/renew.component';
import { ResellerSignupComponent } from './pages/reseller-signup/reseller-signup.component';
import { NewPurchaseComponent } from './pages/new-purchase/new-purchase.component';
import { PurchasePlanComponent } from './pages/purchase-plan/purchase-plan.component';
import { NewPurchase2Component } from './pages/new-purchase2/new-purchase2.component';

const routes: Routes = [
	{
		path: '',
		component: BaseComponent,
		children: [
			{
				path: 'purchase/plan',
				component: PurchasePlanComponent
			},
			{
				path: 'purchase/plan/:discountCode',
				component: PurchasePlanComponent
			},
			{
				path: 'purchase',
				component: NewPurchase2Component
			},
			{
				path: 'purchase/:discountCode',
				component: PurchasePlanComponent,
			},
			{
				path: 'purchase/:productId/:discountCode',
				component: NewPurchase2Component,
			},
			{
				path: 'purchase/:productId',
				component: NewPurchase2Component,
			},
			{
				path: 'purchase/:msg',
				component: NewPurchase2Component,
			},
			// {
			// 	path: 'masspurchase',
			// 	component: MassPurchaseComponent,
			// 	canActivate:[AuthGuard,MassPurchaseGuard]
			// },
			{
				path: 'resellersignup',
				component: ResellerSignupComponent
			},
			// {
			// 	path: 'masspurchase/:bankorderId/:bankTransactionId/:activationCode',
			// 	component: MassPurchaseComponent,
			// 	canActivate:[AuthGuard,MassPurchaseGuard]
			// },
			// {
			// 	path: 'masspurchase/:msg',
			// 	component: MassPurchaseComponent,
			// 	canActivate:[AuthGuard,MassPurchaseGuard]
			// },
			{
				path: 'renew',
				component: RenewComponent
			},
			{ path: '', redirectTo: 'purchase', pathMatch: 'full' },
			{ path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
		]
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PurchaseRoutingModule {
}
